import { render, staticRenderFns } from "./qyClassManFrom.vue?vue&type=template&id=2b056442&scoped=true"
import script from "./qyClassManFrom.vue?vue&type=script&lang=js"
export * from "./qyClassManFrom.vue?vue&type=script&lang=js"
import style0 from "./qyClassManFrom.vue?vue&type=style&index=0&id=2b056442&prod&lang=scss"
import style1 from "./qyClassManFrom.vue?vue&type=style&index=1&id=2b056442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b056442",
  null
  
)

export default component.exports